module.exports = __webpack_public_path__ + "img/imageUnavailable.6e6aa5d8.svg";